import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import SOHImage from '../assets/images/New_features_images/SOH.png';
const NewFeaturesModal = () => {
  const [showModal, setShowModal] = useState(false);


  // Use localStorage to show the modal only once
  useEffect(() => {
    const isFirstVisit2 = localStorage.getItem('Release 1.4.5');
    if (!isFirstVisit2) {
      setShowModal(true);
      localStorage.setItem('Release 1.4.5', 'true');
    }
  }, []);

  const handleClose = () => setShowModal(false);
 
  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Body style={{
        fontFamily: 'Arial, Helvetica, sans-serif',
        background: '#f9fafc',
        color: '#333',
        lineHeight: '1.6',
        padding: '30px',
        borderRadius: '8px'
      }}>
        <div style={{
          background: 'white',
          padding: '30px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
        }}>
          <h1 style={{ color: '#1f3c88' }}>🚀 Release 1.4.5 | 28/05/2026</h1>
          <p><strong>Enhancements and Bug Fixes</strong></p>

          <p>
            This release introduces an on-demand Automotive Intelligence approach, extends battery analytics with new KPIs, 
            and improves performance of large data downloads.
          </p>

          <h2 style={{
            marginTop: '35px',
            color: '#2c3e50',
            borderBottom: '2px solid #eee',
            paddingBottom: '6px'
          }}>🤖 Automotive Intelligence</h2>

          <ul style={{ marginLeft: '20px' }}>
            <li>The <strong>Automotive Intelligence</strong> feature on the <em>Ride Analysis</em> page has been switched to an <strong>on-demand approach</strong> as part of ongoing improvements.</li>
            <li>The feature is now also available on the <strong>Charging</strong> page.</li>
          </ul>

          <h2 style={{
            marginTop: '35px',
            color: '#2c3e50',
            borderBottom: '2px solid #eee',
            paddingBottom: '6px'
          }}>🔋 Extension of Battery KPIs</h2>

          <h3 style={{
            marginTop: '20px',
            color: '#34495e'
          }}>State of Health (SoH) Visualization Update</h3>

          <ul style={{ marginLeft: '20px' }}>
            <li>The <strong>State of Health (SoH)</strong> visualization for fleet selections has been updated:</li>
            <li style={{ marginLeft: '20px' }}>It now shows the <strong>10th to 90th percentile range</strong> instead of a heatmap.</li>
            <li style={{ marginLeft: '20px' }}>This change improves <strong>interpretability based on user feedback</strong>.</li>
          </ul>

          <div style={{
            background: '#fff4e6',
            padding: '15px',
            borderLeft: '4px solid #ff9800',
            borderRadius: '4px',
            marginTop: '10px'
          }}>
            <strong>⚠️ Note on Data Interpretation:</strong>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
              <li>For fleets with a <strong>high number of days since data acquisition</strong>, the SoH curve may increase at later time points.</li>
              <li>This is caused by <strong>low vehicle coverage</strong> in those periods.</li>
              <li>The data is displayed transparently as recorded — please interpret these periods with care.</li>
            </ul>
          </div>

          <div style={{
            marginTop: '20px',
            textAlign: 'center',
            padding: '10px'
          }}>
            <img 
              src={SOHImage} 
              alt="State of Health Visualization" 
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            />
          </div>

          <h3 style={{
            marginTop: '25px',
            color: '#34495e'
          }}>New Battery KPIs (Battery Ageing Model)</h3>

          <p>The following KPIs are now available:</p>

          <ul style={{ marginLeft: '20px' }}>
            <li><strong>Calendaric Aging Matrix</strong></li>
            <li><strong>Cyclic Aging Matrix</strong></li>
            <li><strong>Calendaric Aging Factor</strong></li>
            <li><strong>Calendaric State of Health</strong></li>
            <li><strong>Cyclic State of Health</strong></li>
          </ul>

          <p style={{ fontStyle: 'italic', color: '#666' }}>Cyclic Aging Factor will follow soon.</p>

          <h4 style={{
            marginTop: '15px',
            color: '#34495e'
          }}>KPI Adjustment</h4>

          <ul style={{ marginLeft: '20px' }}>
            <li>The KPI <strong>"Efficiency"</strong> has been removed, as it did not provide the expected analytical insights.</li>
          </ul>

          <h2 style={{
            marginTop: '35px',
            color: '#2c3e50',
            borderBottom: '2px solid #eee',
            paddingBottom: '6px'
          }}>📥 Download Functionality Improvements</h2>

          <ul style={{ marginLeft: '20px' }}>
            <li>If a dataset exceeds the size limit of Excel (.xlsx), the download is <strong>automatically provided as a .csv file</strong>.</li>
            <li>The <strong>download timeout has been increased</strong> to support larger vehicle scopes and longer time periods.</li>
            <li>If the selected dataset still exceeds system limits:
              <ul style={{ marginLeft: '20px' }}>
                <li>An <strong>error message</strong> will be displayed</li>
                <li>Please <strong>reduce the scope (vehicles and/or time period)</strong> and retry</li>
              </ul>
            </li>
          </ul>
        </div>
      
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewFeaturesModal;
